module.exports = __webpack_public_path__ + "static/media/stage_background.dd92d841.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/stage_background.jpg
// module id = 336
// module chunks = 0